import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRightArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 16,
	viewBox: "0 0 19 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.7071 0.292893C11.3166 -0.0976311 10.6834 -0.0976311 10.2929 0.292893C9.90237 0.683417 9.90237 1.31658 10.2929 1.70711L15.5858 7H1C0.447715 7 0 7.44772 0 8C0 8.55229 0.447715 9 1 9H15.5858L10.2929 14.2929C9.90237 14.6834 9.90237 15.3166 10.2929 15.7071C10.6834 16.0976 11.3166 16.0976 11.7071 15.7071L18.7071 8.70711C19.0976 8.31658 19.0976 7.68342 18.7071 7.29289L11.7071 0.292893Z",
		fill: "currentColor"
	})
});
export default SvgRightArrow;
